import { lazy, Suspense, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Areas from "./components/Areas";
import Details from "./components/Details";
import UserManagement from "./components/UserManagement";
import SiteSettings from "./components/SiteSettings";
import StatisticDetails from "./components/StatisticDetails";
import UserSettings from "./components/UserSettings";
import { SiteProvider, useSite } from "./context/SiteContext";
import { ThemeProvider } from "./context/ThemeContext";
import { useTokenManager } from "./utils/tokenRefresher";
import WhatsNewController from "./components/WhatsNewController";
import EnvironmentBanner from "./components/EnvironmentBanner";
import UpdateBanner from "./components/UpdateBanner";

// separate chunk: customers never download the admin portal code
const AdminPortal = lazy(() => import("./components/admin/AdminPortal"));

function AppInner({ username }) {
  const { resetContext } = useSite();
  useTokenManager(resetContext);
  return null;
}

function App() {
  const [username, setUsername] = useState("");

  return (
    <ThemeProvider>
    <SiteProvider>
      <AppInner username={username} />
      <EnvironmentBanner />
      <UpdateBanner />
      <div className="app-layout">
        <Header username={username} />

        <main className="app-content">
          <Routes>
            <Route path="/" element={<Login setUsername={setUsername} />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/areas" element={<Areas username={username} />} />
            <Route path="/details" element={<Details username={username} />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/site-settings" element={<SiteSettings />} />
            <Route path="/admin/*" element={<Suspense fallback={null}><AdminPortal /></Suspense>} />
            <Route path="/statistics" element={<StatisticDetails />} />
            <Route path="/settings" element={<UserSettings />} />
          </Routes>
        </main>

        <WhatsNewController />
      </div>
    </SiteProvider>
    </ThemeProvider>
  );

}

export default App;
